// src/components/ColorfulLoader.jsx
import React, { useEffect, useState } from "react";
import {
  FaReact,
  FaJs,
  FaAngular,
  FaNodeJs,
  FaDatabase,
  FaJava,
} from "react-icons/fa";
import {
  SiTypescript,
  SiSpring,
  SiNextdotjs,
  SiExpress,
  SiMongodb,
  SiPostgresql,
  SiOracle,
} from "react-icons/si";
import "./ColorfulLoader.css";

const ColorfulLoader = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  const techStack = [
    // { icon: <FaReact />, color: "#61DAFB", name: "React" },
    // { icon: <FaReact />, color: "#61DAFB", name: "React" },
    { icon: <FaJava />, color: "#007396", name: "Java" },
    { icon: <SiTypescript />, color: "#007ACC", name: "TypeScript" },
    { icon: <FaJs />, color: "#F7DF1E", name: "JavaScript" },
    // { icon: <FaAngular />, color: "#DD0031", name: "Angular" },
    // { icon: <SiNextdotjs />, color: "#000000", name: "Next.js" },
    { icon: <SiSpring />, color: "#6DB33F", name: "Spring" },
    { icon: <FaNodeJs />, color: "#68A063", name: "Node.js" },
    // { icon: <SiExpress />, color: "#000000", name: "Express" },
  ];

  return (
    <div className="circular-loader-container">
      <div className="tech-icons-grid">
        {techStack.map((tech, index) => (
          <div
            key={index}
            className="tech-icon-circle"
            style={{
              "--delay": `${index * 0.1}s`,
              "--bg-color": tech.color,
              "--text-color": tech.color === "#000000" ? "white" : "black",
            }}
            title={tech.name}
          >
            <div className="tech-icon-wrapper">{tech.icon}</div>
          </div>
        ))}
      </div>
      <div className="loader-title">
        <h2>Digital Transformation Expert</h2>
        <p>ID4 Specialist | Full-Stack Developer</p>
      </div>
    </div>
  );
};

export default ColorfulLoader;
